import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const ChallengeDetailClosedStatus = () => {
    return (_jsxs(Container, { children: [_jsx(View, { style: { flexGrow: 1 } }), _jsxs(BubbleContainer, { children: [_jsx(BubbleTextContainer, { children: _jsx(BubbleText, { allowFontScaling: false, children: "\uCC4C\uB9B0\uC9C0\uAC00 \uC885\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4" }) }), _jsx(BubbleTail, { source: require('../../../assets/img/img_challenge_bubble_tail.png') })] }), _jsx(AstronutImage, { source: require('../../../assets/img/img_challenge_closed_astronut.png') })] }));
};
export default ChallengeDetailClosedStatus;
const Container = styled.View({
    flexDirection: 'row',
    paddingTop: 46,
});
const BubbleContainer = styled.View({
    flexDirection: 'row',
    flexShrink: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 7,
});
const BubbleTextContainer = styled.View({
    backgroundColor: color.brandColor,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 8,
});
const BubbleTail = styled.Image({
    width: 16,
    height: 8,
    transform: 'rotateZ(270deg)',
    marginLeft: -4,
    tintColor: color.brandColor,
});
const BubbleText = styled.Text({
    color: color.white,
    fontSize: 16,
    fontFamily: font.pretendardBold,
});
const AstronutImage = styled.Image({
    width: 108,
    height: 88,
    marginRight: 15,
});
